import React, { useEffect, useRef } from "react";

const ChatMessage = ({ messages, chatType }) => {
	const containerRef = useRef(null);

	useEffect(() => {
		if (containerRef.current) {
			containerRef.current.scrollTop = containerRef.current.scrollHeight;
		}
	}, [messages]);

	return (
		<div
			ref={containerRef}
			className="flex flex-col h-[400px] sm:h-[500px] pt-10 pb-3 overflow-auto px-3 w-full">
			{chatType === "ChatBot" ? (
				<div className="flex flex-col font-thin tracking-wider leading-6 justify-start w-[70%] rounded-t-lg rounded-br-lg bg-neutral-800 p-2 mb-2 text-sm text-neutral-200">
					<span>Hey there! 🙂</span>
					<span>How can {chatType} assist you today?</span>
				</div>
			) : (
				<div
					className={`flex flex-col font-thin tracking-wider leading-6 justify-start w-[70%] p-2 mb-2 text-sm ${
						chatType === "ChatBot"
							? "text-neutral-200 bg-neutral-800"
							: "font-IBM text-green-600 backdrop-blur-lg border-[0.5px] border-green-600"
					}`}>
					<span>{`<<-- Ask ${chatType} anything — it's here to assist with general information and support. -->>`}</span>
				</div>
			)}
			{messages.map((msg, idx) => (
				<div
					key={idx}
					className={`flex items-center ${
						msg?.role === "user" ? "justify-end" : "justify-start"
					} mb-2`}>
					<span
						className={` backdrop-blur-lg  p-2 font-thin text-sm tracking-wider leading-6 max-w-[70%] ${
							chatType === "ChatBot"
								? "text-neutral-200"
								: "font-IBM text-green-600"
						} ${
							msg?.role === "user"
								? [
										chatType === "ChatBot"
											? "bg-neutral-500 text-neutral-50 rounded-lg"
											: "border-[0.5px] border-green-600",
										"text-end",
								  ].join(" ")
								: chatType === "ChatBot"
								? "bg-neutral-800 text-neutral-300 rounded-lg"
								: "border-[0.5px] border-green-600"
						} ${msg?.role === "user" && "rounded-br-none"} ${
							msg?.role === "model" && "rounded-bl-none"
						}`}>
						{msg.text}
					</span>
				</div>
			))}
		</div>
	);
};

export default ChatMessage;
